module.exports = __webpack_public_path__ + "img/kucing_Nocalcu.f99a88de.svg";